import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import { BOOKS_FOR_PAGE, API_URL } from '@/helpers/variables';
import SeriesDetail from '@/components/screens/series-detail/SeriesDetail';
import { ISeriesBooksPage } from '@/interfaces/seriesBooksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface ISeriesPageDynamicProps extends IWidgetsSideBar {
  books: ISeriesBooksPage;
}

const SeriesPageDynamic: NextPage<ISeriesPageDynamicProps> = ({ books, todayWidget, popularBooksWidget }) => {
  return <SeriesDetail books={books} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias } = context.query;

  const booksRes = await fetch(`${API_URL}series/?alias=${alias}&status=active&page=1&page_size=${BOOKS_FOR_PAGE}&book_page=1&book_page_size=${BOOKS_FOR_PAGE}`);

  // Check fetch error
  if (!booksRes.ok) {
    console.table(`Error ${booksRes.status}. Api: ${booksRes.url}`);
    return {
      notFound: true,
    };
  }

  const books = await booksRes.json();

  // Check Fetched Data Error
  if (!books?.data || !(Number(books.data.length) > 0)) {
    return {
      notFound: true,
    };
  }

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return {
    props: { books, todayWidget, popularBooksWidget },
  };
};

export default SeriesPageDynamic;
